// extracted by mini-css-extract-plugin
export var container = "styles-module--container--b08cb";
export var contentDiv = "styles-module--content-div--a9ad8";
export var numbers = "styles-module--numbers--845bf";
export var textCol = "styles-module--text-col--e97c9";
export var title = "styles-module--title--d2bd3";